import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  snackbarOpen: false,
  snackbarMessage: "",
  snackbarMessageSeverity: "",
}

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setAlertMessageSnackbarOpen: (state, action) => {
      state.snackbarOpen = action.payload;
    },
    setAlertMessageSnackbarMsg: (state, action) => {
      state.snackbarMessage = action.payload;
    },
    setAlertMessageSnackbarMessageSeverity: (state, action) => {
      state.snackbarMessageSeverity = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    }
  }
});

export const { setAlertMessageSnackbarMessageSeverity, setAlertMessageSnackbarOpen, setAlertMessageSnackbarMsg, setLoading } = feedbackSlice.actions;

export default feedbackSlice.reducer;